export class CreateCampaignModel {
    name: string;
    description: string;
    startDate: Date;
    endDate: Date;
    stampsObjective: number;
    campaignRewardName: string;
    campaignRewardDescription: string;
    voucherDuration: string;
    recurrencePattern : string;
}